export default __webpack_public_path__ + "/dist/images/9445802.7552f92014e555d646757619922e4f46.png";